// @ts-nocheck
import * as types from 'redux/actions/projects';
import { addTime, subTime } from 'utils/dateUtils';
import { normalizeDateString } from 'utils/dateUtils/utilities';
import { TimeUnit } from 'types/date';
export const initialState = {
  loader: false,
  projects: [],
  pagination: {
    totalPages: null,
    total: null,
    perPage: localStorage.getItem('per_page') || 25,
    pageNumber: 1,
  },
  filter: {
    states: [],
    projectTypes: [],
    projectStatus: [1],
    clients: [],
    example: false,
  },
  filterByDate: {
    startDate: subTime(new Date(), 30, TimeUnit.MONTHS),
    endDate: addTime(new Date(), 30, TimeUnit.MONTHS),
  },
  searchText: '',
  form: {
    code: '',
    name: '',
    purchase_order_number: null,
    contract_number: null,
    description: '',
    start_date: new Date(),
    end_date: addTime(new Date(), 1, TimeUnit.MONTHS),
    plan_budget: 0,
    actual_budget: 0,
    status: 1,
    segment: [],
    subs_segment: [],
    tracking_category: '',
    assign_to: [],
    street_address_one: '',
    street_address_two: '',
    postal_code: '',
    suburb_city: '',
    country: '',
    state: '',
    client: '',
    latitude: '',
    longitude: '',
    // location: '',
    lead_client_contact_person: '',
    project_lead_role_id: '',
    lead_project_contact_person_assigne: '',
    lead_project_contact_person_assigne_array: [],
    claim_payment_act: '',
    resource_code_list_template: '',
    require_contract_work_insurance: false,
    is_manual: true,
    upload_contract_programme: '',
    upload_estimation_sheet: '',
    cost_centres: [],
  },
  formErr: {},
  countries: [],
  clientList: [],
  segments: [],
  paymentActs: [],
  templates: [],
  states: [],
  showConfirmationModal: false,
  selectedProjectId: null,
  deleteProjectSuccess: false,
  showClientFormModal: false,
  showResourceCodeAssignmentModal: false,
  shouldImportUnidentifiedResourceCodes: false,
  resourceCode: {
    header: [],
    rows: [],
    unidentified: [],
    hasUnidentifiedResourceCodes: false,
  },
  success: false,
  isButtonLoading: false,
};

function projectReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.POST_PROJECT_REQUEST:
      return {
        ...state,
        isButtonLoading: true,
      };
    case types.POST_PROJECT_SUCCESS:
      return {
        ...state,
        isButtonLoading: false,
      };
    case types.POST_PROJECT_FAILURE:
      return {
        ...state,
        isButtonLoading: false,
      };
    case types.UPDATE_PROJECT_BY_ID_REQUEST:
      return {
        ...state,
        isButtonLoading: true,
      };
    case types.UPDATE_PROJECT_BY_ID_SUCCESS:
      return {
        ...state,
        isButtonLoading: false,
      };
    case types.UPDATE_PROJECT_BY_ID_FAILURE:
      return {
        ...state,
        isButtonLoading: false,
      };
    case types.GET_PROJECTS_REQUEST:
      return {
        ...state,
        loader: true,
      };
    case types.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        loader: false,
        projects: action.payload.data,
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action?.payload?.per_page || 25,
          total: action.payload.total,
          pageNumber: action?.payload?.current_page || 1,
        },
      };
    case types.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload,
      };

    case types.GET_PROJECT_SEGMENT_SUCCESS:
      return {
        ...state,
        segments: action.payload,
      };
    case types.GET_PROJECT_STATES_SUCCESS:
      return {
        ...state,
        states: action.payload,
      };

    case types.GET_PROJECT_CLIENT_SUCCESS:
      return {
        ...state,
        clientList: action.payload,
      };
    case types.GET_PROJECT_CLAIMPAYMENT_SUCCESS:
      return {
        ...state,
        paymentActs: action.payload,
      };

    case types.GET_PROJECT_CODELIST_SUCCESS:
      return {
        ...state,
        templates: action.payload,
      };

    case types.FILTER_PROJECTS:
      return filterProjects(state, action);

    case types.FILTER_PROJECTS_BY_DATE:
      return filterProjectsByDate(state, action);

    case types.UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload.text,
      };

    case types.UPDATE_FORM_FIELD:
      return updateFormField(state, action);

    case types.RESET_FORM_FIELD:
      return {
        ...state,
        form: initialState.form,
      };

    case types.UPDATE_FORM_FIELD_ERR:
      return {
        ...state,
        formErr: action.payload.errors,
      };

    case types.RESET_FORM_FIELD_ERR:
      return {
        ...state,
        formErr: {},
      };

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedProjectId: action.payload.selectedProjectId,
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
        selectedProjectId: null,
      };

    case types.UPDATE_PAGINATION_PAGE_NUMBER:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageNumber: action.payload.pageNumber,
        },
      };

    case types.UPDATE_PAGINATION_PER_PAGE:
      return updatePerPage(state, action);

    case types.GET_PROJECT_BY_ID_SUCCESS:
      return getProjectSuccess(state, action);

    case types.OPEN_CLIENT_FORM_MODAL: {
      return {
        ...state,
        showClientFormModal: true,
      };
    }

    case types.CLOSE_CLIENT_FORM_MODAL: {
      return {
        ...state,
        showClientFormModal: false,
      };
    }

    case types.GENERATE_ASSIGNEE_FORM:
      return generateAssigneeForm(state, action);

    case types.REMOVE_ASSIGNEE_FORM:
      return removeAssigneeForm(state, action);

    case types.SELECT_PROJECT_ASSIGNEE:
      return selectProjectAssignee(state, action);

    case types.DELETE_PROJECT_REQUEST:
      return {
        ...state,
        deleteProjectSuccess: false,
      };

    case types.FAVOURITE_PROJECT_SUCCESS:
      return {
        ...state,
        projects: state.projects.map((each) => {
          if (each.id === action.payload.project) {
            return {
              ...each,
              favourite: action.payload.favourite,
            };
          }
          return each;
        }),
      };
    case types.DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        deleteProjectSuccess: true,
      };

    case types.OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL:
      return {
        ...state,
        showResourceCodeAssignmentModal: true,
      };

    case types.CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL:
      return {
        ...state,
        showResourceCodeAssignmentModal: false,
      };
    case types.CHECK_UNIDENTIFIED_RESOURCE_CODE_REQUEST:
      return {
        ...state,
        isButtonLoading: true,
      };

    case types.CHECK_UNIDENTIFIED_RESOURCE_CODE_SUCCESS: {
      const {
        payload: { header, rows, unidentified },
      } = action;
      return {
        ...state,
        isButtonLoading: false,
        resourceCode: {
          header,
          rows,
          unidentified,
          hasUnidentifiedResourceCodes: unidentified.length > 0,
        },
      };
    }

    case types.CHECK_UNIDENTIFIED_RESOURCE_CODE_FAILURE:
      return {
        ...state,
        isButtonLoading: false,
      };

    case types.SET_IMPORT_UNIDENTIFIED_RESOURCE_CODES:
      return setImportUnidentifiedResourceCodes(state, action);

    default: {
      return state;
    }
  }
}

const setImportUnidentifiedResourceCodes = (state, action) => {
  const {
    payload: { value },
  } = action;

  return {
    ...state,
    shouldImportUnidentifiedResourceCodes: value,
  };
};

const filterProjects = (state, action) => {
  const {
    payload: { type, values },
  } = action;
  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: values,
    },
  };
};

const filterProjectsByDate = (state, action) => {
  const {
    payload: { startDate, endDate },
  } = action;
  return {
    ...state,
    filterByDate: {
      startDate,
      endDate,
    },
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = { ...state.pagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  localStorage.setItem('per_page', clonedPagination.perPage);
  return {
    ...state,
    pagination: clonedPagination,
  };
};

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;
  return {
    ...state,
    form: {
      ...state.form,
      [name]: value,
    },
    success: true,
    formErr: {
      ...state.formErr,
      [name]: '',
    },
  };
};

const generateAssigneeForm = (state, _action) => {
  const _maxVal = Math.max(...state.form.assign_to.map((form) => form.uid), 0);
  return {
    ...state,
    form: {
      ...state.form,
      assign_to: [...state.form.assign_to, { user_id: null, role_id: null }],
    },
  };
};

const removeAssigneeForm = (state, action) => {
  const filteredArray = state.form.assign_to.filter(
    (_, index) => index !== action.payload.index,
  );

  return {
    ...state,
    form: {
      ...state.form,
      assign_to: filteredArray,
    },
  };
};

const selectProjectAssignee = (state, action) => {
  const {
    payload: { userId, roleId },
  } = action;

  return {
    ...state,

    form: {
      ...state.form,
      assign_to: [
        ...state.form.assign_to,
        { user_id: userId, role_id: roleId },
      ],
    },
    formErr: {
      ...state.formErr,
      assign_to: '',
    },
  };
};

const toSegmentIds = (items) =>
  (items ?? []).map((item) =>
    typeof item === 'string' ? item : (item?.id ?? item),
  );

const getProjectSuccess = (state, action) => {
  const {
    payload: {
      start_date,
      end_date,
      lead_project_contact_person_assigne,
      assign_to,
      lead_project_contact_person_assigne_array,
      segment,
      subs_segment,
    },
  } = action;

  let project_lead_user_id = lead_project_contact_person_assigne;
  let project_lead_role_id = '';

  if (
    typeof lead_project_contact_person_assigne === 'object' &&
    lead_project_contact_person_assigne !== null
  ) {
    project_lead_user_id = lead_project_contact_person_assigne.id;

    project_lead_role_id = lead_project_contact_person_assigne.groups[0];
  }

  const parsedLeadContactPerson = JSON.parse(
    lead_project_contact_person_assigne_array || '[]',
  )?.[0];

  const leadContactFirstName = lead_project_contact_person_assigne?.first_name;
  const leadContactLastName = lead_project_contact_person_assigne?.last_name;

  const getLeadContactFullName = () => {
    if (leadContactFirstName) {
      return `${leadContactFirstName} ${leadContactLastName}`;
    }
    if (parsedLeadContactPerson?.id) {
      return parsedLeadContactPerson['full name'];
    }
    return '';
  };

  const leadContactPerson = {
    'full name': getLeadContactFullName(),
    email:
      lead_project_contact_person_assigne?.email ||
      parsedLeadContactPerson?.email ||
      '',
    is_archived:
      lead_project_contact_person_assigne?.user_archived ||
      parsedLeadContactPerson?.is_active,
    id: project_lead_user_id,
  };
  return {
    ...state,
    form: {
      ...action.payload,
      start_date: new Date(normalizeDateString(start_date)),
      end_date: new Date(normalizeDateString(end_date)),
      segment: toSegmentIds(segment),
      subs_segment: toSegmentIds(subs_segment),
      assign_to: assign_to?.map((assignee) => ({
        ...assignee,
        user_id: assignee.id,
        role_id: assignee.groups[0],
      })),
      upload_estimation_sheet: null,
      upload_contract_programme: null,
      lead_project_contact_person_assigne: project_lead_user_id,
      lead_project_contact_person_assigne_array: [leadContactPerson],
      project_lead_role_id,
    },
  };
};

export default projectReducer;
